var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4168 15.5C28.4168 22.6339 22.634 28.4167 15.5002 28.4167C8.36629 28.4167 2.5835 22.6339 2.5835 15.5C2.5835 8.36612 8.36629 2.58333 15.5002 2.58333C22.634 2.58333 28.4168 8.36612 28.4168 15.5Z",
    stroke: "#EA5B0C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 10.3437C3.875 10.3437 7.66863 14.2083 13.4811 14.2083C17.4375 14.2083 19.5378 11.9182 21.3125 11.3098C24.6489 10.1654 27.125 10.3437 27.125 10.3437M3.875 18.0937C3.875 18.0937 6.57329 17.9154 10.208 19.0598C12.143 19.6669 14.4305 21.9583 18.7421 21.9583C22.6326 21.9583 25.6925 20.5 27.475 19.375",
    stroke: "#EA5B0C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.f9e43f60f50def0477cb11b36bcd8ec4.svg";
export { ForwardRef as ReactComponent };